<template>
  <div>
    <nav-title :color="false" :title="'Problem solving saved'" />

    <empty-module
      v-if="getConfigList.length == 0"
      :title="'You have not saved any solving problem yet.'"
      :icon="'contact_support'"
    />

    <section v-else class="container">
      <p class="p-3 mx-lg-5">
        Please choose one of the previously created problem solving solutions.
      </p>
      <help-saved-list :problems-saved="getConfigList" @onClickDelete="handleDeleteProblem" />
    </section>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import store from '@/store';
import navTitle from '@/components/general/navTitle.vue';
import emptyModule from '@/components/general/emptyModule.vue';
import { HelpSavedList } from '@/components/help';
import notificationToastMixin from '@/mixins/notificationToast.mixin';

export default {
  components: {
    navTitle,
    emptyModule,
    HelpSavedList,
  },
  mixins: [notificationToastMixin],
  computed: {
    ...mapGetters('help', ['getConfigList']),
    ...mapGetters('user', ['getUserId']),
  },
  beforeRouteEnter(to, from, next) {
    let parentId = store.getters['user/getUserId'];
    Promise.all([store.dispatch('help/FetchConfig', parentId)]).then(() => {
      next();
    });
  },
  methods: {
    ...mapActions('help', ['deleteProblemSolving']),
    async handleDeleteProblem({ problemId }) {
      try {
        await this.deleteProblemSolving({ parentId: this.getUserId, problemId });
      } catch (error) {
        this.notificationToast({
          message: error.message,
          variant: 'danger',
          title: 'Problem Solving',
        });
        console.log(error);
      }
    },
  },
};
</script>
